import React from "react";
import locale from "../../locale";

class LayoutLoading extends React.Component
{
	render()
	{
		return (
			<div className="page-loading-container">{locale.get('page-loading-title')}</div>
		);
	}
}

export default LayoutLoading;
